import { useMemo } from 'react';
import { get } from 'lodash';
import { daysAdded, getDaysFromTimeslots } from '../../../util/dates';
import { getLodgingPricesOptions } from '../../../util/listing';
import { getPackageLodgingPrices } from '../../../util/package';
import { formatCalendarInfoDays } from '../inquiryPackageModel';

const useInquiryLodging = ({
  listing,
  selectedPackage,
  timeSlots,
  intl,
  lodgingAddons,
  startDate,
  endDate,
  isSingleDay,
}) =>
  useMemo(() => {
    const { guests, price, hasLodging, days } = selectedPackage || {};
    const { max: maxParty, min: minParty = 1 } = { ...guests };
    const maxDiyPartySize = get(listing, 'attributes.publicData.policies.sportsmen', 1);
    const availableDays = getDaysFromTimeslots(timeSlots);
    const lodgingPricesOptions = getLodgingPricesOptions(listing, intl);
    const { optionalLodging } = getPackageLodgingPrices(selectedPackage, lodgingPricesOptions);
    const includeLodgings = lodgingAddons?.length > 0 || hasLodging;
    const tripLength = startDate && endDate ? daysAdded(startDate, endDate) : 0;

    return {
      optionalLodging: optionalLodging || [],
      availableDays,
      hasLodging,
      days,
      price,
      minParty,
      maxParty,
      maxDiyPartySize,
      dynamicHasLodging: Boolean(includeLodgings && tripLength > 1),
      calendarInfoDays: formatCalendarInfoDays(days),
      showAddOns: Boolean(optionalLodging?.length > 0 && days && (days.min > 1 || !isSingleDay)),
    };
  }, [listing, selectedPackage, timeSlots, intl, lodgingAddons, startDate, endDate, isSingleDay]);

export default useInquiryLodging;
